import React from "react";

interface RichTextNode {
  nodeType: string;
  content?: RichTextNode[];
  value?: string;
  marks?: { type: string }[];
}

/**
 * Recursive function to render Contentful's rich text structure as React elements.
 */
export const renderRichText = (node: RichTextNode): React.ReactNode => {
  switch (node.nodeType) {
    case "document":
      return <>{node.content?.map((child, index) => renderRichText(child))}</>;

    case "paragraph":
      return (
        <p>
          {node.content?.map((child, index) => (
            <React.Fragment key={index}>{renderRichText(child)}</React.Fragment>
          ))}
        </p>
      );

    case "text":
      const isBold = node.marks?.some((mark) => mark.type === "bold");

      // Handle line breaks in text value
      const parts = node.value?.split("\n") || [];
      return parts.map((part, index) => (
        <React.Fragment key={index}>
          {isBold ? (
            <strong className="text-transparent font-bold bg-clip-text bg-gradient-to-r from-backgroundLight to-primary">
              {part}
            </strong>
          ) : (
            part
          )}
          {index < parts.length - 1 && <br />}
        </React.Fragment>
      ));

    default:
      console.warn(`Unhandled node type: ${node.nodeType}`);
      return null;
  }
};
